import React, { useState } from 'react';
import { Modal, Typography } from 'antd';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import { catalogImageUrl } from '../../images';

const { Text } = Typography;

/**
 * Lets the admin draw a rectangle on the variation's current image and returns
 * the selection as a normalized rect ({x,y,width,height} in 0..1) — the backend
 * applies it to the full-resolution image, so the displayed size doesn't matter.
 */
export const ImageCropModal = ({ open, imageId, busy, onCancel, onConfirm }) => {
    const [crop, setCrop] = useState();
    const [completed, setCompleted] = useState(null);

    const handleOk = () => {
        if (!completed?.width || !completed?.height) return;
        onConfirm({
            x: completed.x / 100,
            y: completed.y / 100,
            width: completed.width / 100,
            height: completed.height / 100,
        });
    };

    return (
        <Modal
            title="Crop image"
            open={open}
            width={560}
            okText="Crop"
            okButtonProps={{ disabled: !completed?.width, loading: busy }}
            onOk={handleOk}
            onCancel={onCancel}
            afterClose={() => {
                setCrop(undefined);
                setCompleted(null);
            }}
        >
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                {imageId && (
                    <ReactCrop
                        crop={crop}
                        onChange={(_, percentCrop) => setCrop(percentCrop)}
                        onComplete={(_, percentCrop) => setCompleted(percentCrop)}
                    >
                        <img
                            src={catalogImageUrl(imageId, 480)}
                            alt="crop source"
                            style={{ maxWidth: '100%', maxHeight: 480 }}
                        />
                    </ReactCrop>
                )}
            </div>
            <Text type="secondary" style={{ display: 'block', marginTop: 8, fontSize: 12 }}>
                Drag to select the region to keep — applied to every variant of this variation.
            </Text>
        </Modal>
    );
};
